import { useQuery } from '@apollo/client';
import { useCurrentAccount } from '@application/api';
import { graphql } from '@gql/gql';
import type {
  AccountGetBuyerUnpaidApplicationsQuery,
  AccountGetBuyerUnpaidApplicationsQueryVariables,
} from '@gql/graphql';
import { DogBreederApplicationStatus } from '@gql/graphql';

export const ACCOUNT_GET_BUYER_UNPAID_APPLICATIONS = graphql(`
  query AccountGetBuyerUnpaidApplications($where: DogBreederApplicationWhereInput) {
    accountMe {
      id
      applications(where: $where) {
        id
        dogBreeder {
          id
          profileImg
        }
        breedPreference {
          translations {
            language
            name
          }
        }
      }
    }
  }
`);

export const useGetBuyerUnpaidApplications = () => {
  const { currentAccountType } = useCurrentAccount();

  const { data, loading } = useQuery<
    AccountGetBuyerUnpaidApplicationsQuery,
    AccountGetBuyerUnpaidApplicationsQueryVariables
  >(ACCOUNT_GET_BUYER_UNPAID_APPLICATIONS, {
    variables: {
      where: { status: { equals: DogBreederApplicationStatus.AWAITING_PAYMENT } },
    },
    ssr: false,
    skip: currentAccountType !== 'buyer',
  });

  return {
    unpaidApplications: data?.accountMe?.applications ?? [],
    unpaidApplicationsLoading: loading,
  };
};
